import { AgencyImagesApiClient } from '@fourthwall/services/dist/AgencyImagesApiClient'
import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'
import { useMutation } from '@tanstack/react-query'

type Payload = Parameters<typeof ShopsApiClient.updateShopStatus>[1]

export const useShopStatusMutation = () => {
  const shopStatusMutation = useMutation({
    mutationFn: async ({ shopId, payload }: { shopId: string; payload: Payload }) => {
      const { data } = await ShopsApiClient.updateShopStatus(shopId, payload)

      return data
    },
  })

  return { shopStatusMutation }
}

export const useUploadAgencyImageMutation = createMutationHook(AgencyImagesApiClient.uploadImage, {
  mutationKey: ['uploadAgencyImage'],
})
